/**
 * @author:
 * @file: description
 * @Date: 2020-05-06 18:00:07
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-12 18:37:34
 */
import React from 'react';
import { render } from 'react-dom';
import axios from '@tkit/ajax/lib/axios';
import store from './store';
import routeConfig from './common/routeConfig';
import Root from './Root';
import 'antd/dist/antd.less';
import 'noform-json/dist/index.css';
import 'nowrapper-json/dist/antd/index.css';
axios.defaults.timeout = 20000;
/** kstack 区分请求客户端 pc-pc端  mobile--移动端*/
axios.defaults.headers = {
  ['X-Agent']: 'pc'
};

declare global {
  /* eslint-disable no-var */
  var LocalDataMessages: Root.LocalDataMessages;
  /* eslint-disable no-var */
  interface NodeModule {
    hot: any;
  }
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION__: any;
  }
}

import './styles/index.less';
// import { setCookie } from './utils/cookie';
// 临时写登录cookie
// setCookie(
//   'kuaishou.ee.juxingBbs_st',
//   'ChhrdWFpc2hvdS5lZS5qdXhpbmdCYnMuc3QSsAHoTTa80za30LfoVPQOXCFR2X0RxtISAbH5GB7uDm5Xq__Q5YIKD1i7F4zac_E1PjFk6lwfr8lcAwoM4qhAZCUe0_XscC27WC6xlWi0-EnGSf23EW8BQed31Hx9Pfzqv3BuPFL1dnQJGtObm73WAylfmMVNfyNvVwhlbjNyLxRP7RwDyduzIFByJTdzVDokvMvTDe1JB1ZtRQhOA1TYmgBmVvfnVQDq6uLVayiUHKiS_RoSxj66cagqFPwtrXrD0dG0mKiLIiB2cmtkmyCmFd2qHkWSMBbGGIpbMYlxmA5kWyzsN9UxrCgFMAE'
// );
// setCookie('did', 'web_153c6482d2aa4abebace13592eb6641bc734');
// setCookie('userId', '2148802833');

function renderApp<P>(app: React.ReactElement<P>) {
  render(app, document.getElementById('root'));
}

renderApp(<Root store={store} routeConfig={routeConfig} />);

// Hot Module Replacement API
/* istanbul ignore if  */
if (module.hot) {
  module.hot.accept('./common/routeConfig', () => {
    import(
      /* webpackChunkName: "route" */ './common/routeConfig'
    ).then(({ default: nextRouteConfig }) =>
      renderApp(<Root store={store} routeConfig={nextRouteConfig} />)
    );
  });
  module.hot.accept('./Root', () => {
    import(/* webpackChunkName: "root" */ './Root').then(() =>
      renderApp(<Root store={store} routeConfig={routeConfig} />)
    );
  });
}
